<label class="estado-bsc" [ngClass]="{
    'asignada': estadoDeEntrega === 'Asignada',
    'entregada': estadoDeEntrega === 'Entregada',
    'devuelta': estadoDeEntrega === 'Devuelta',
    'calificada': estadoDeEntrega === 'Devuelta',
    'estado-bsc__classroom': submission
}">{{estadoDeEntrega}}</label>